import type { Question } from "@/schema/quizSchema";

type SingleQuestion = Extract<Question, { type: "single" }>;

export function SingleChoice({
  question,
  value,
  onAnswer,
}: {
  question: SingleQuestion;
  value: string | undefined;
  onAnswer: (value: string) => void;
}) {
  return (
    <fieldset style={{ border: 0, margin: 0, padding: 0 }}>
      <legend className="qk-prompt">{question.prompt}</legend>
      {question.helper && (
        <p className="qk-helper" data-qk-helper>
          {question.helper}
        </p>
      )}
      <div style={{ display: "grid", gap: "0.5rem" }}>
        {question.options.map((opt) => (
          <button
            key={opt.value}
            type="button"
            className="qk-option"
            aria-pressed={value === opt.value}
            onClick={() => onAnswer(opt.value)}
          >
            {opt.emoji ? `${opt.emoji} ` : ""}
            {opt.label}
          </button>
        ))}
      </div>
    </fieldset>
  );
}
